import axios from "axios";
import { getUrl } from "@/common/config";
//import fakeHS from "@/api/json/fake/historicalShifts";

export default class MachineShiftsApi {
  constructor() {
    this.url = getUrl();
  }

  getShiftKpis(machineFamily) {
    return axios
      .get(`${this.url}/api/v2/machines/kpis`, { params: { machineFamily } })
      .then(response => response.data.result);
  }

  getMachineShifts(machineId) {
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/shifts`)
      .then(response => response.data.result);
  }

  saveMachineShifts(machineId, shifts) {
    return axios.put(`${this.url}/api/v2/machines/${machineId}/shifts`, shifts);
  }

  getCurrentMachineShift(machineId) {
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/shifts/current?progress=true`)
      .then(response => response.data.result)
      .catch(() => {
        return null;
      });
  }

  getShiftsHistorical(machineId, search) {
    // Return fake
    //return new Promise((resolve, reject) => {
    //  resolve(fakeHS)
    //})
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/shifts/history`, { params: search })
      .then(response => {
        return response.data;
      });
  }

  async getCurrentMachinesShift(machines) {
    let result = [];

    if (machines) {
      const params = machines.map(el => this.getCurrentMachineShift(el.Id));

      const shifts = await Promise.all(params);
      result = (shifts || []).map((el, index) => {
        return {
          machine: machines[index],
          currentShift: el
        };
      });
    }

    return result;
  }
}
